module.exports = "/_next/static/images/cfa0aa6c2a77cbbf95548c945de999c6-fees-right.jpg";